import styled from 'styled-components';

export const Container = styled.form`
  display: grid;

  grid-template-columns: repeat(2, 1fr); /* Two columns */
  grid-template-rows: auto auto auto; /* Three rows */

  & > :nth-child(1) {
    grid-column: 1;
    grid-row: 1;
  } /* First item */

  & > :nth-child(2) {
    grid-column: 2;
    grid-row: 1;
  } /* Second item */

  & > :nth-child(3) {
    grid-column: 1 / span 2; /* Span full width */
    grid-row: 2;
  } /* Third item */

  & > :nth-child(4) {
    grid-column: 2;
    grid-row: 3;
  } /* Last item aligned right */

  gap: 10px;
  margin: 0;
`;
